import React from 'react';
import { Globe, Building, Lock, ShieldAlert } from 'lucide-react';

/**
 * Badge de nivel de confidencialidad
 * Niveles: publico, interno, confidencial, secreto
 */
export default function ConfidentialityBadge({ nivel, size = 'sm' }) {
  const sizeClasses = {
    sm: 'px-2 py-0.5 text-xs',
    md: 'px-3 py-1 text-sm'
  };

  const iconSizes = {
    sm: 12,
    md: 14
  };

  const confidentialityConfig = {
    publico: {
      label: 'Público',
      icon: Globe,
      bgColor: 'bg-blue-50',
      textColor: 'text-blue-600',
      borderColor: 'border-blue-200'
    },
    interno: {
      label: 'Interno',
      icon: Building,
      bgColor: 'bg-gray-50',
      textColor: 'text-gray-600',
      borderColor: 'border-gray-200'
    },
    confidencial: {
      label: 'Confidencial',
      icon: Lock,
      bgColor: 'bg-orange-50',
      textColor: 'text-orange-600',
      borderColor: 'border-orange-200'
    },
    secreto: {
      label: 'Secreto',
      icon: ShieldAlert,
      bgColor: 'bg-red-50',
      textColor: 'text-red-600',
      borderColor: 'border-red-200'
    }
  };

  const config = confidentialityConfig[nivel] || confidentialityConfig.interno;
  const Icon = config.icon;

  return (
    <span className={`
      inline-flex items-center gap-1 font-medium rounded border
      ${sizeClasses[size]}
      ${config.bgColor}
      ${config.textColor}
      ${config.borderColor}
    `}>
      <Icon size={iconSizes[size]} />
      {config.label}
    </span>
  );
}
